import React from 'react';
import { SimpleProduct } from '@msdyn365-commerce/retail-proxy';

const ProductCode = ({
    product,
    resources
}: {
    product?: SimpleProduct;
    resources: {
        webCodeLabel: string;
        mfrCodeLabel: string;
    };
}) => {
    const [itemId, mfrCode] = React.useMemo(() => {
        const mfrCode = product?.ExtensionProperties?.find(p => p.Key === 'MfrCode')?.Value?.StringValue;
        return [product?.ItemId, mfrCode];
    }, [product]);

    return (
        <span>
            {resources.webCodeLabel}: {itemId ?? ''}
            {mfrCode && ` ${String.fromCharCode(183)} ${resources.mfrCodeLabel}: ${mfrCode}`}
        </span>
    );
};

export { ProductCode };
